import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { ResourceType } from '../types/resource';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import {
  BiContextProvidedValue,
  BiData,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';

export interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  comment: PapiComment;
}

export const CommentLink: React.FC<Props> = ({
  comment,
  children,
  ...restProps
}) => {
  return (
    <BiLink
      href={Url.commentLink(comment.typeId, comment.itemId, comment.commentId)}
      biData={BiData<ItemClickBiEvent>({
        evid: 100,
        typeid: ResourceType.COMMENT,
        itemid: comment.commentId,
        creatorid: comment.user?.useridUuid,
        page_typeid: BiContextProvidedValue,
        page_itemid: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
      })}
      {...restProps}
    >
      {children}
    </BiLink>
  );
};
CommentLink.displayName = 'CommentLink';

export default CommentLink;
